
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment'
import { getTimeString } from '../../util/datetime';


export const determineClient = (allClients, client_ids) => {
    let clientUserName;
    Object.values(allClients).map(client => {
        if (client.user_id_number == client_ids) {
            clientUserName = client.user_name
        }
    })
    return clientUserName;
}

export const mapToDays = (days) => {
    let mappedDays = (days.split(",")).map(item => {
        switch (item) {
            case "0": return "Sun";
            case "1": return "Mon";
            case "2": return "Tue";
            case "3": return "Wed";
            case "4": return "Thu";
            case "5": return "Fri";
            case "6": return "Sat";
        }
    })
    return mappedDays;
}

export const openLink = (url) => window.open(url, '_blank')?.focus();

// for calendar download
export function createIcsFile(
    startDate,
    endDate,
    summary,
    description,
    recurString,
    endDateFormatted) {

    let icsMSG;
    if (recurString) {
        recurString = recurString + ";UNTIL=" + endDateFormatted + "T000000"
    }

    icsMSG =
        "BEGIN:VCALENDAR\n" +
        "CALSCALE:GREGORIAN\n" +
        "METHOD:PUBLISH\n" +
        "PRODID:-//Cal//EN\n" +
        "VERSION:2.0\n" +
        "BEGIN:VEVENT\n" +
        `UID:${uuidv4()}\n` +
        "TZID:" +
        Intl.DateTimeFormat().resolvedOptions().timeZone +
        "\n" +
        "DTSTART;VALUE=DATE-TIME:" +
        startDate +
        "\n" +
        "DTEND;VALUE=DATE-TIME:" +
        endDate

    // if recurring event add this to icsMSG
    if (recurString) {
        icsMSG = icsMSG + "\n" + recurString
    }

    icsMSG = icsMSG
        +
        "\n" +
        "SUMMARY:" +
        summary +
        "\n" +
        "DESCRIPTION:" +
        description +
        "\n" +
        "END:VEVENT\n" +
        "END:VCALENDAR";


    var blob = new Blob([icsMSG], { type: 'text/calendar;charset=utf-8' });


    let icsFile = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = "event";
    link.click();
    // manually revoke the object URL to avoid memory leaks.
    window.URL.revokeObjectURL(icsFile);

    return icsFile;

}

export function createLink(
    download,
    {startDate, startTime},
    {endDate, endTime, noEndDate},
    title,
    description,
    repeatType,
    repeatWeekDays="",
    interval
) {

    console.log(endDate,"endDate");
    let urlEncodedTitle = encodeURIComponent(title);
    let urlEncodedDescription = encodeURIComponent(description);

    let startDateFormatted = moment(startDate).format("YYYYMMDD");
    let startTimeFormatted = (getTimeString(startTime)).split(":").join("");

    //either a recurring event with specified end date or noEndDate=true, 
    // or single event which means startDate = endDate

    let endDateFormatted = (endDate && !noEndDate) ? moment(endDate).format("YYYYMMDD") : startDateFormatted

    let endTimeFormatted = (getTimeString(endTime)).split(":").join("");

    let dateURL = startDateFormatted + "T" + startTimeFormatted + "/" + endDateFormatted + "T" + endTimeFormatted



    let byDay;
    let freq;
    let recurString;


    if (repeatType === 'day') {
        freq = "DAILY"
        recurString = `RRULE:FREQ=${freq};INTERVAL=${interval}`
    } else if (repeatType == "week") {
        freq = "WEEKLY"
        let standardizedWeekDay = repeatWeekDays.map(item => (item.slice(0, 2)))
        byDay = standardizedWeekDay.join(",").toUpperCase();
        recurString = `RRULE:FREQ=${freq};INTERVAL=${interval};WKST=MO;BYDAY=${byDay}`
    }


    let urlEncodedRecurString = encodeURIComponent(recurString)
    if (urlEncodedRecurString) {
        urlEncodedRecurString = `${urlEncodedRecurString}`
    }

    let url;
    if (repeatType == "none") {
        url = `https://www.google.com/calendar/render?action=TEMPLATE&text=${urlEncodedTitle}&details=${urlEncodedDescription}&dates=${dateURL}`
    } else {
        url = `https://www.google.com/calendar/render?action=TEMPLATE&text=${urlEncodedTitle}&details=${urlEncodedDescription}&dates=${dateURL}&recur=${urlEncodedRecurString ? urlEncodedRecurString : ""}`
    }

    if (download) {
        createIcsFile(startDateFormatted + "T" + startTimeFormatted, startDateFormatted + "T" + endTimeFormatted, title, description, recurString, endDateFormatted);
    } else {
        openLink(url);
    }
}

export function determineInterval(repeatValue, dailyString, customDayString, weekRepeatFreq) {

    return repeatValue === "day" ?
        //if daily custom then use custom daily string
        dailyString === "custom" ?
            customDayString :
            // otherwise regular daily string
            dailyString :
        //if week repeat
        repeatValue === "week" ?
            weekRepeatFreq :
            // not week or day then empty string
            ""
}


// helper function to determine whether permission to delete event exists

export const determineDeletePermissions = (isClient, isTrainerOrGym, status) => (
    // clients can delete pending/rejected events
    (isClient && (status === 0 || status === 2) ||
    // trainers can delete accepted events
    (isTrainerOrGym && status != "0")
))

//Credit: https://raw.githubusercontent.com/vborodulin/add-event-to-calendar/master/src/index.tsx

export type TCalendarEvent = {
  name: string;
  details: string | null;
  location: string | null;
  startsAt: string;
  endsAt: string;
  rrule: string | null;
}

const makeDuration = (event: TCalendarEvent) => {
  const minutes = Math.floor((+new Date(event.endsAt) - +new Date(event.startsAt)) / 60 / 1000);
  return `${Math.floor(minutes / 60)}:${`0${minutes % 60}`.slice(-2)}`;
};

const makeTime = (time: string) => new Date(time).toISOString().replace(/[-:]|\.\d{3}/g, '');

type Query = { [key: string]: null | boolean | number | string };

const makeUrl = (base: string, query: Query) => Object.keys(query).reduce(
  (accum, key, index) => {
    const value = query[key];

    if (value !== null) {
      return `${accum}${index === 0 ? '?' : '&'}${key}=${encodeURIComponent(value)}`;
    }
    return accum;
  },
  base
);

export const makeGoogleCalendarUrl = (event: TCalendarEvent) => makeUrl('https://calendar.google.com/calendar/render', {
  action: 'TEMPLATE',
  dates: `${makeTime(event.startsAt)}/${makeTime(event.endsAt)}`,
  location: event.location,
  recur:event.rrule,
  text: event.name,
  details: event.details,
});

export const makeOutlookCalendarUrl = (event: TCalendarEvent) => makeUrl('https://outlook.live.com/owa', {
  rru: 'addevent',
  startdt: event.startsAt,
  enddt: event.endsAt,
  subject: event.name,
  location: event.location,
  body: event.details,
  allday: false,
  repeat:event.rrule.split('RRULE:')[1],
  uid: new Date().getTime().toString(),
  path: '/calendar/view/Month',
});

export const makeICSCalendarUrl = (event: TCalendarEvent) => {
  const components = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'BEGIN:VEVENT',
    `TZID:${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
    `URL:${document.URL}`,
    `DTSTART:${makeTime(event.startsAt)}`,
    `DTEND:${makeTime(event.endsAt)}`,
    event.rrule || '',
    `SUMMARY:${event.name}`,
    `DESCRIPTION:${event.details}`,
    `LOCATION:${event.location}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ];

  return encodeURI(`data:text/calendar;charset=utf8,${components.join('\n')}`);
};


//end credit: //Credit: https://raw.githubusercontent.com/vborodulin/add-event-to-calendar/master/src/index.tsx